import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';
import { useDeleteConversionPairMutation } from '../store/conversion-pairs-api';
import { getConversionPairTitle } from '../utils/helpers/converter';
import { handleConversionPairError } from '../utils/helpers/conversion-pairs-errors';

import type { TConversionPair } from '../store/types';

export const useDeleteConversionPair = () => {
  const [deleteConversionPair, { isLoading, isSuccess, error }] = useDeleteConversionPairMutation();
  const deleteError = handleConversionPairError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Торговая пара успешно удалена',
    error: deleteError,
  });

  const openDeleteModal = (item: TConversionPair) => modals.openConfirmModal({
    title: `Удаление пары ${getConversionPairTitle(item)}`,
    centered: true,
    children: `Вы точно хотите удалить торговую пару ${getConversionPairTitle(item)}?`,
    labels: { confirm: 'Удалить', cancel: 'Отмена' },
    confirmProps: { color: 'red' },
    onConfirm: async () => await deleteConversionPair({ pairId: item.id }),
  });

  return {
    isLoading,
    openDeleteModal,
  };
};
